import { createContext, useMemo, useContext } from 'react';
import { isValidAnswerSetTypeForQuestion } from './answer-set-utils';
import standardAnswerSets from 'js/ydoc/docs/common/standard-answer-sets';

import NullChoiceEditor from './NullChoiceEditor';
import NullSettings from './NullSettings';
import ScoredChoiceEditor from './ScoredChoiceEditor';
import ScoredChoiceSettings from './ScoredChoiceSettings';
import SingleSelectChoiceEditor from './SingleSelectChoiceEditor';
import MultiSelectChoiceSettings from './MultiSelectChoiceSettings';
import MultiSelectChoiceEditor from './MultiSelectChoiceEditor';
import SentimentOptions from 'js/components/Assessment/Editors/LiveAssessmentEditor/Questions/SentimentOptions';

export function defaultGetComponents(questionType) {
  switch (questionType) {
    case 'sentiment':
      return {
        ChoiceEditor: SentimentOptions,
        Settings: ScoredChoiceSettings,
      };

    case 'likert':
    case 'unscored-likert':
      return {
        ChoiceEditor: ScoredChoiceEditor,
        Settings: ScoredChoiceSettings,
      };

    case 'long-text':
      return {
        ChoiceEditor: NullChoiceEditor,
        Settings: NullSettings,
      };

    case 'multi-select':
      return {
        ChoiceEditor: MultiSelectChoiceEditor,
        Settings: MultiSelectChoiceSettings,
      };

    case 'single-select':
      return {
        ChoiceEditor: SingleSelectChoiceEditor,
        Settings: MultiSelectChoiceSettings,
      };

    default:
      return {
        ChoiceEditor: NullChoiceEditor,
        Settings: NullSettings,
      };
  }
}

// const { ChoiceEditor } = getComponents(question?.type);
// const isValidAnswerSet = isValidAnswerSetTypeForQuestion(
//   question.type,
//   answerSet?.type
// );

export const AnswerSetContext = createContext({
  getComponents: defaultGetComponents,
  isValidAnswerSetTypeForQuestion,
  standardAnswerSets,
});

export function AnswerSetContextProvider({ value, children }) {
  const defaultContext = useContext(AnswerSetContext);

  const context = useMemo(() => {
    return {
      ...defaultContext,
      ...value,
    };
  }, [defaultContext, value]);

  return (
    <AnswerSetContext.Provider value={context}>
      {children}
    </AnswerSetContext.Provider>
  );
}

export function useAnswerSetContext() {
  return useContext(AnswerSetContext);
}
